import "./frontPage/receivingDiscrepanciesForm";
import "./lookup.js";



// WEBPACK FOOTER //
// ./src/pages/receivingDiscrepancies/index.js